import Route from '@ember/routing/route';

export default class ControlTimeRoute extends Route 
{
	model() 
	{
		return this.modelFor("event");
	}
}
